module.exports = __webpack_public_path__ + "img/slogan.fd0a8b81.png";